/* Armora — shared behaviour for the new design sections.

   1. Scroll reveal: elements marked .reveal fade and lift into place once.
   2. Tabbed products: switches panels.
   3. Horizontal scrollers: tab rows and the gallery carousel. Handles mouse
      drag, prev / next buttons, a progress bar and the soft edge fades.

   IntersectionObserver is used for the reveal rather than scroll offsets so it
   works regardless of which element is the scroll container. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- reveal -- */

  function initReveal() {
    var items = document.querySelectorAll('.reveal:not([data-revealed])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      [].forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    [].forEach.call(items, function (el) {
      el.setAttribute('data-revealed', '1');
      io.observe(el);
    });
  }

  /* --------------------------------------------------------------- tabs -- */

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      if (root.dataset.tabsReady === '1') return;
      root.dataset.tabsReady = '1';

      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-tab-btn]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
      if (!buttons.length) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab-btn');

          buttons.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', String(on));
          });

          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id);
          });

          if (btn.scrollIntoView) {
            btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          }

          initReveal();
        });
      });
    });
  }

  /* ---------------------------------------------------------- scrollers -- */

  function initScrollers() {
    document.querySelectorAll('[data-scroller-root]').forEach(function (root) {
      var rail = root.querySelector('[data-scroller]');
      if (!rail || root.dataset.scrollerReady === '1') return;
      root.dataset.scrollerReady = '1';

      var prev = root.querySelector('[data-scroller-prev]');
      var next = root.querySelector('[data-scroller-next]');
      var bar = root.querySelector('[data-scroller-bar]');

      function measure() {
        var max = rail.scrollWidth - rail.clientWidth;
        var overflow = max > 2;
        var atStart = rail.scrollLeft <= 1;
        var atEnd = rail.scrollLeft >= max - 1;

        root.classList.toggle('has-overflow', overflow);
        root.classList.toggle('at-start', atStart);
        root.classList.toggle('at-end', atEnd);

        if (prev) prev.disabled = !overflow || atStart;
        if (next) next.disabled = !overflow || atEnd;

        if (bar) {
          /* Width of the thumb tracks how much of the rail is on screen. */
          var ratio = overflow ? rail.clientWidth / rail.scrollWidth : 1;
          var travel = overflow ? rail.scrollLeft / max : 0;
          bar.style.width = (ratio * 100).toFixed(2) + '%';
          bar.style.marginLeft = (travel * (100 - ratio * 100)).toFixed(2) + '%';
        }
      }

      function step(dir) {
        var first = rail.firstElementChild;
        var amount = first ? first.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      rail.addEventListener('scroll', measure, { passive: true });
      window.addEventListener('resize', measure, { passive: true });
      measure();
      /* Images change the rail width as they load. */
      window.addEventListener('load', measure);
      setTimeout(measure, 900);

      /* Drag to scroll with a mouse; touch already works natively. */
      var down = false, startX = 0, startLeft = 0, moved = false;

      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button > 0) return;
        down = true; moved = false;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
      });

      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
        rail.scrollLeft = startLeft - dx;
      });

      function up() { down = false; rail.classList.remove('is-dragging'); }
      rail.addEventListener('pointerup', up);
      rail.addEventListener('pointerleave', up);
      rail.addEventListener('pointercancel', up);
      rail.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  function boot() {
    initReveal();
    initTabs();
    initScrollers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
